<div class="deposit-source-type-container">
  <div class="form-element">
    <p
      [innerHtml]="
        (mortgageApplication.isPurchase
          ? referenceDataLabels.DepositSource
          : referenceDataLabels.DepositSourceForRemortgage
        ) | localizeLabel
      "
      class="source-of-deposit-title"
    ></p>
  </div>
  <boi-validation-error [propertyNames]="['ApplicationDepositSourceTypes']"></boi-validation-error>

  <ng-container *ngIf="mortgageApplication.ApplicationDepositSourceTypes">
    <div
      class="deposit-source-type vo-panel-grey p-15 px-md-0 my-15"
      *ngFor="
        let depositSourceType of mortgageApplication.ApplicationDepositSourceTypes;
        index as depositSourceTypeIndex
      "
    >
      <div class="d-flex justify-content-between mx-15">
        <p class="applicant-savings" [innerHtml]="getDepositSourceTypeLabel(depositSourceType)"></p>
        <button
          class="remove-button vo-icon vo-icon-recycle-bin cursor-pointer"
          [disabled]="mortgageApplication?.IsApplicationReadOnly"
          (click)="removeDepositSourceType(depositSourceType)"
          title="Remove"
        ></button>
      </div>

      <boi-form-numeric-input
        [fieldMaxLength]="8"
        [isFieldDisabled]="
          mortgageApplication?.IsApplicationReadOnly ||
          (mortgageApplication?.IsFactFindReadOnly && mortgageApplication?.IsFactFind)
        "
        [controlId]="'DepositSourceTypeAmount ' + depositSourceTypeIndex"
        [labelName]="
          mortgageApplication.isPurchase
            ? referenceDataLabels.DepositSourceTypeAmount
            : referenceDataLabels.DepositSourceTypeAmountForRemortgage
        "
        [isCurrency]="true"
        [(value)]="depositSourceType.DepositSourceTypeAmount"
        [propertyNames]="['ApplicationDepositSourceType_' + depositSourceTypeIndex + '.DepositSourceTypeAmount']"
        [contextualHelpName]="
          mortgageApplication.isPurchase
            ? referenceDataLabels.HelpApplicationDepositSourceTypes
            : referenceDataLabels.HelpApplicationDepositSourceTypes
        "
      >
      </boi-form-numeric-input>

      <ng-container *ngIf="areDetailsRequired(depositSourceType)">
        <boi-form-textarea
          [controlId]="'DepositSourceTypeDetails ' + depositSourceTypeIndex"
          [labelName]="
            mortgageApplication.isPurchase
              ? referenceDataLabels.DepositSourceTypeDetails
              : referenceDataLabels.DepositSourceTypeDetailsForRemortgage
          "
          [propertyNames]="['ApplicationDepositSourceType_' + depositSourceTypeIndex + '.DepositSourceTypeDetails']"
          [isFieldDisabled]="
            mortgageApplication?.IsApplicationReadOnly ||
            (mortgageApplication?.IsFactFindReadOnly && mortgageApplication?.IsFactFind)
          "
          [(value)]="depositSourceType.DepositSourceTypeDetails"
          [fieldMaxLength]="1500"
          [contextualHelpName]="
            mortgageApplication.isPurchase
              ? referenceDataLabels.HelpApplicationDepositSourceTypes
              : referenceDataLabels.HelpApplicationDepositSourceTypes
          "
        >
        </boi-form-textarea>
      </ng-container>
    </div>
  </ng-container>

  <div class="add-new-deposit vo-panel-grey d-flex my-15 align-items-md-center">
    <boi-form-option-list
      [isFieldDisabled]="
        mortgageApplication?.IsApplicationReadOnly ||
        (mortgageApplication?.IsFactFindReadOnly && mortgageApplication?.IsFactFind)
      "
      [optionList]="referenceDataOptionLists.DepositSourceType"
      [contextualHelpName]="
        mortgageApplication.isPurchase
          ? referenceDataLabels.HelpApplicationDepositSourceTypes
          : referenceDataLabels.HelpApplicationDepositSourceTypesForRemortgage
      "
      [labelName]="
        mortgageApplication.isPurchase
          ? referenceDataLabels.AddNewDepositSourceTypeCode
          : referenceDataLabels.AddNewDepositSourceTypeCodeForRemortgage
      "
      [(value)]="selectedDepositSourceTypeCode"
    ></boi-form-option-list>

    <button
      class="primary-button vo-secondary-button-1"
      (click)="addNewDepositSourceType()"
      [disabled]="
        !selectedDepositSourceTypeCode ||
        !canAddDepositSourceType() ||
        mortgageApplication?.IsApplicationReadOnly ||
        (mortgageApplication?.IsFactFindReadOnly && mortgageApplication?.IsFactFind)
      "
      title="{{ referenceDataLabels.Add | localizeLabel }}"
    >
      {{ referenceDataLabels.Add | localizeLabel }}
    </button>
  </div>
</div>
